import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

export interface IClinicWalletsActionProps {
  abc: string;
}

AxiosCurlirize(axios, () => {});

export const useClinicCashCollectAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (API_OPERATION?: string, API_SOURCE?: string, data: any) => {
      dispatch(
        setLoading({
          key: "isCollectAmountDataInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .post(
            `${DAY_CLOSING_APIS?.APPOITNTMENT_STATUS?.baseURL}${API_OPERATION}/reconciliation/${API_SOURCE}`,
            data,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              dispatch(
                setLoading({
                  key: "isCollectAmountDataInProgress",
                  status: false,
                }),
              );
              return { status: true };
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCollectAmountDataInProgress",
                status: false,
              }),
            );
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
